/**
 * 打开 mfuns 深链
 * @param path 业务路径，例如 "user/123"
 */
export function openApp(path: string): void {
  try {
    const schemeProtocol = 'mfuns'
    const schemeHost = 'net.mfuns.app.asuka'
    const fallbackUrl = '/download'
    const timeoutDuration = 2000

    const appSchemeUrl = `${schemeProtocol}://${schemeHost}/${path}`

    window.location.href = appSchemeUrl

    const timer = setTimeout(() => {
      window.location.href = fallbackUrl
    }, timeoutDuration)
  } catch (error) {
    console.error('打开应用失败:', error)
  }
}
